import { NgModule } from '@angular/core'
import { NodeListComponent } from './node-list.component'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { SharedModule } from '../../../../shared/shared.module'
import { EventFilterListModule } from '../../../events/components/event-filter-list/event-filter-list.module'
import { VideoListModule } from '../../../videos/components/video-list/video-list.module'
import { NodeTypeListModule } from '../node-type-list/node-type-list.module'
import { SearchFiltersModule } from 'src/app/libs/search-filters/search-filters.module'
import { TableModule } from 'src/app/libs/table/table.module'
import { MessageModule } from '../../../message/message.module'

@NgModule({
  exports: [NodeListComponent],
  declarations: [NodeListComponent],
  imports: [
    CommonModule,
    EventFilterListModule,
    NodeTypeListModule,
    VideoListModule,
    RouterModule,
    SharedModule,
    SearchFiltersModule,
    TableModule,
    MessageModule
  ]
})
export class NodeListModule {}
